import React from 'react';
import PropTypes from 'prop-types';

import ALink from 'tradera-components/alink/alink';

const MenuItem = ({
    alerts,
    bold,
    border,
    className,
    follow,
    gaAttributes,
    icon,
    imageUrl,
    inSPA,
    label,
    link,
    notify,
    notificationDot,
    onClick
}) => {
    const containerClass = `site-dropdown__item d-flex flex-row align-items-center ${
        alerts?.length > 0 ? 'flex-wrap' : ''
    } ${className} `;

    return (
        <li className={`${border ? 'border-bottom' : ''}`}>
            {link ? (
                <ALink
                    useLink={inSPA}
                    href={link}
                    className={containerClass}
                    {...(!follow && { rel: 'nofollow' })}
                    {...gaAttributes}
                    onClick={onClick}>
                    <MenuItemContent
                        alerts={alerts}
                        bold={bold}
                        icon={icon}
                        imageUrl={imageUrl}
                        label={label}
                        notify={notify}
                        notificationDot={notificationDot}
                    />
                </ALink>
            ) : (
                <div className={containerClass} onClick={onClick}>
                    <MenuItemContent
                        alerts={alerts}
                        bold={bold}
                        icon={icon}
                        imageUrl={imageUrl}
                        label={label}
                        notify={notify}
                        notificationDot={notificationDot}
                    />
                </div>
            )}
        </li>
    );
};

const MenuItemContent = ({
    icon,
    bold,
    imageUrl,
    label,
    notify,
    alerts,
    notificationDot
}) => {
    return (
        <>
            {icon && (
                <span
                    className="site-dropdown__item__image d-flex align-items-center justify-content-center"
                    style={{ backgroundImage: imageUrl }}>
                    {icon}
                </span>
            )}
            <span
                className={`flex-grow pr-1 text-wrap ${
                    bold ? 'font-weight-bold' : ''
                }`}>
                {label}
            </span>

            <NotificationDot
                notify={notify}
                notificationDot={notificationDot}
            />

            {alerts}
        </>
    );
};

const NotificationDot = ({ notify, notificationDot }) => {
    if (notify > 0) {
        return (
            <span className="d-flex ml-auto">
                <span className="mr-3 badge badge-primary badge-pill-round">
                    {notify}
                </span>
            </span>
        );
    }

    switch (notificationDot) {
        case 'info':
        case 'success':
        case 'warning':
        case 'danger':
            return (
                <span className="d-flex ml-auto">
                    <span
                        className={`mr-3 site-dropdown__notification rounded-circle bg-${notificationDot}`}
                    />
                </span>
            );
        default:
            return null;
    }
};

MenuItem.propTypes = {
    bold: PropTypes.bool,
    border: PropTypes.bool,
    gaAttributes: PropTypes.object,
    inSPA: PropTypes.bool,
    label: PropTypes.node,
    link: PropTypes.string,
    notify: PropTypes.number
};

MenuItem.defaultProps = {
    bold: false,
    border: false,
    className: 'site-dropdown__item-default',
    follow: true,
    inSPA: false,
    notify: 0
};

export default MenuItem;
